import type { ReactNode } from "react";
import { BrandMark } from "@frontend/components/brand-logo";

/**
 * Shared frame for /login and /signup. One composition: intro, the form panel,
 * then the switch link. The soft pool behind the panel is what keeps the page
 * from reading as a white card dropped on flat grey.
 */
export function AuthShell({
  title,
  description,
  children,
  footer,
}: {
  title: string;
  description: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <main className="relative flex flex-1 flex-col">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-[28rem] bg-[radial-gradient(ellipse_70%_80%_at_50%_-10%,var(--color-surface),transparent)]"
        aria-hidden="true"
      />

      <div className="relative mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-4 py-12 sm:py-16">
        <div className="text-center">
          <BrandMark className="mx-auto h-7 w-[2.4rem]" />
          <h1 className="mt-5 text-3xl font-semibold tracking-tight text-balance">{title}</h1>
          <p className="mx-auto mt-2.5 max-w-sm text-[15px] leading-relaxed text-ink-muted text-pretty">
            {description}
          </p>
        </div>

        <div className="relative mt-8">
          <div
            className="still-glow pointer-events-none absolute -inset-8 sm:-inset-10"
            aria-hidden="true"
          />
          <div className="relative rounded-2xl border border-line bg-surface p-6 shadow-[0_24px_60px_-28px_rgb(11_13_18/0.28)] sm:p-7">
            {children}
          </div>
        </div>

        {footer ? <div className="mt-6 text-center text-sm text-ink-muted">{footer}</div> : null}
      </div>
    </main>
  );
}
